import { BUTTON } from '@lumapps/wrex-button/constants';
import { ELEMENTS as BUTTON_ELEMENTS } from '@lumapps/wrex-button/plugin/html/deserialize/elements';
import { CODE_BLOCK } from '@lumapps/wrex-code-block/constants';
import { COLUMN, COLUMNS } from '@lumapps/wrex-columns/constants';
import { ELEMENTS as COLUMNS_ELEMENTS } from '@lumapps/wrex-columns/plugin/html/deserialize/elements';
import { EMBEDDED_MAP } from '@lumapps/wrex-embedded-map/constants';
import { ELEMENTS as EMBEDDED_MAP_ELEMENTS } from '@lumapps/wrex-embedded-map/plugin/html/deserialize/elements';
import { EMBEDDED_VIDEO } from '@lumapps/wrex-embedded-video/constants';
import { ELEMENTS as EMBEDDED_VIDEO_ELEMENTS } from '@lumapps/wrex-embedded-video/plugin/html/deserialize/elements';
import { IMAGE_GROUP } from '@lumapps/wrex-enhanced-image/constants';
import { ELEMENTS as IMAGE_ELEMENTS } from '@lumapps/wrex-enhanced-image/plugin/html/deserialize/elements';
import { FILE } from '@lumapps/wrex-file/constants';
import { ELEMENTS as FILE_ELEMENTS } from '@lumapps/wrex-file/plugin/html/deserialize/elements';
import { HTMLPasteOptions } from '@lumapps/wrex-html-paste/types';
import { IFRAME } from '@lumapps/wrex-iframe/constants';
import { ELEMENTS as IFRAME_ELEMENTS } from '@lumapps/wrex-iframe/plugin/html/deserialize/elements';
import { LINK_PREVIEW } from '@lumapps/wrex-link-preview/constants';
import { ELEMENTS as LINK_PREVIEW_ELEMENTS } from '@lumapps/wrex-link-preview/plugin/html/deserialize/elements';
import { LINK } from '@lumapps/wrex-link/constants';
import { ELEMENTS as LINK_ELEMENTS } from '@lumapps/wrex-link/plugin/html/deserialize/elements';
import { LIST_ITEM, ORDERED_LIST, UNORDERED_LIST } from '@lumapps/wrex-list/constants';
import { ELEMENTS as LIST_ELEMENTS } from '@lumapps/wrex-list/plugin/html/deserialize/elements';
import { PLAY_VIDEO } from '@lumapps/wrex-play-video/constants';
import { ELEMENTS as PLAY_VIDEO_ELEMENTS } from '@lumapps/wrex-play-video/plugin/html/deserialize/elements';
import { QUOTE_BLOCK } from '@lumapps/wrex-quote/constants';
import { ELEMENTS as QUOTE_ELEMENTS } from '@lumapps/wrex-quote/plugin/html/deserialize/elements';
import { T_D, T_R, TABLE } from '@lumapps/wrex-table/constants';
import { ELEMENTS as TABLE_ELEMENTS } from '@lumapps/wrex-table/plugin/html/deserialize/elements';
import {
    BOLD,
    COLORED,
    DIVIDER,
    HEADING,
    HEADLINE,
    INLINE_CODE,
    ITALIC,
    PARAGRAPH,
    STRIKETHROUGH,
    SUBTITLE,
    TITLE,
    UNDERLINE,
} from '@lumapps/wrex-typography/constants';
import { ELEMENTS as TYPOGRAPHY_ELEMENTS } from '@lumapps/wrex-typography/plugin/html/deserialize/elements';
import { MARKS as MARKS_ELEMENTS } from '@lumapps/wrex-typography/plugin/html/deserialize/marks';
import { USER_MENTION } from '@lumapps/wrex-user-mention/constants';
import { ELEMENTS as USER_MENTION_ELEMENTS } from '@lumapps/wrex-user-mention/plugin/html/deserialize/elements';

const HTML_PASTE_ELEMENTS = {
    [PARAGRAPH]: TYPOGRAPHY_ELEMENTS[PARAGRAPH],
    [HEADING]: TYPOGRAPHY_ELEMENTS[HEADING],
    [HEADLINE]: TYPOGRAPHY_ELEMENTS[HEADLINE],
    [TITLE]: TYPOGRAPHY_ELEMENTS[TITLE],
    [CODE_BLOCK]: TYPOGRAPHY_ELEMENTS[CODE_BLOCK],
    [INLINE_CODE]: TYPOGRAPHY_ELEMENTS[INLINE_CODE],
    [SUBTITLE]: TYPOGRAPHY_ELEMENTS[SUBTITLE],
    [DIVIDER]: TYPOGRAPHY_ELEMENTS[DIVIDER],
    [UNORDERED_LIST]: LIST_ELEMENTS[UNORDERED_LIST],
    [ORDERED_LIST]: LIST_ELEMENTS[ORDERED_LIST],
    [LIST_ITEM]: LIST_ELEMENTS[LIST_ITEM],
    [IMAGE_GROUP]: IMAGE_ELEMENTS[IMAGE_GROUP],
    [USER_MENTION]: USER_MENTION_ELEMENTS[USER_MENTION],
    [LINK_PREVIEW]: LINK_PREVIEW_ELEMENTS[LINK_PREVIEW],
    [LINK]: LINK_ELEMENTS[LINK],
    [TABLE]: TABLE_ELEMENTS[TABLE],
    [T_R]: TABLE_ELEMENTS[T_R],
    [T_D]: TABLE_ELEMENTS[T_D],
    [QUOTE_BLOCK]: QUOTE_ELEMENTS[QUOTE_BLOCK],
    [IFRAME]: IFRAME_ELEMENTS[IFRAME],
    [EMBEDDED_MAP]: EMBEDDED_MAP_ELEMENTS[EMBEDDED_MAP],
    [EMBEDDED_VIDEO]: EMBEDDED_VIDEO_ELEMENTS[EMBEDDED_VIDEO],
    [PLAY_VIDEO]: PLAY_VIDEO_ELEMENTS[PLAY_VIDEO],
    [FILE]: FILE_ELEMENTS[FILE],
    [BUTTON]: BUTTON_ELEMENTS[BUTTON],
    [COLUMNS]: COLUMNS_ELEMENTS[COLUMNS],
    [COLUMN]: COLUMNS_ELEMENTS[COLUMN],
} as const;

const HTML_PASTE_MARKS = {
    [BOLD]: MARKS_ELEMENTS[BOLD],
    [ITALIC]: MARKS_ELEMENTS[ITALIC],
    [COLORED]: MARKS_ELEMENTS[COLORED],
    [STRIKETHROUGH]: MARKS_ELEMENTS[STRIKETHROUGH],
    [UNDERLINE]: MARKS_ELEMENTS[UNDERLINE],
} as const;

export const getHtmlPasteOptions = ({
    elements,
    marks,
}: {
    elements: (keyof typeof HTML_PASTE_ELEMENTS)[];
    marks: (keyof typeof HTML_PASTE_MARKS)[];
}): HTMLPasteOptions => {
    const htmlPasteElements = elements.map((element) => HTML_PASTE_ELEMENTS[element]);
    const htmlPasteMarks = marks.map((mark) => HTML_PASTE_MARKS[mark]);

    return {
        elements: htmlPasteElements,
        marks: htmlPasteMarks,
        allowedAlignments: [PARAGRAPH, HEADING, HEADLINE, TITLE, SUBTITLE],
        defaultBlockType: PARAGRAPH,
    };
};
